module.exports = __webpack_public_path__ + "static/media/zapsplat_office_pen_biro_ball_point_tap_003_49694.b980ea41.wav";